import { AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';

export function installationsDatoValidator(formControl: AbstractControl): ValidationErrors {
  if (!formControl.parent) {
    return null;
  }

  if (!formControl.parent.get('installationDate') || !formControl.parent.get('komponenter')) {
    return null;
  }

  const installationdate = formControl.parent.get('installationDate');
  const komponenter = formControl.parent.get('komponenter');

  var err = false;

  if (installationdate.value) {
    komponenter.value.forEach((komponent) => {
      if (moment(komponent.installationDate).isBefore(moment(installationdate.value))) {
        err = true;
      }
    });
  }

  return err ? { komponent: 'Komponent kan ikke være ældre end anlæg.' } : null;
}
